import React from "react";

export const TIER_META = {
  bronze:   { name: "Bronze",   color: "#A87C51", price: 149 },
  silver:   { name: "Silver",   color: "#75818C", price: 249 },
  gold:     { name: "Gold",     color: "#D4AF37", price: 399 },
  platinum: { name: "Platinum", color: "#1F2937", price: 699 },
};

export function TierBadge({ tier, size = "sm" }) {
  if (!tier) return null;
  const meta = TIER_META[tier];
  if (!meta) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm font-bold uppercase tracking-wider ${
        size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1"
      }`}
      style={{ color: meta.color, border: `1px solid ${meta.color}55` }}
      data-testid={`tier-badge-${tier}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.name}
    </span>
  );
}

export const STATUS_LABELS = {
  new: "New",
  enriched: "Enriched",
  qualified: "Qualified",
  tier_suggested: "Tier Suggested",
  outreach_sent: "Outreach Sent",
  replied: "Replied",
  negotiating: "Negotiating",
  converted: "Converted",
  unsubscribed: "Unsubscribed",
  not_a_fit: "Not a Fit",
};

const STATUS_COLORS = {
  new: "bg-gray-100 text-gray-700 border-gray-300",
  enriched: "bg-blue-50 text-blue-700 border-blue-200",
  qualified: "bg-sky-50 text-sky-800 border-sky-200",
  tier_suggested: "bg-emerald-50 text-emerald-800 border-emerald-200",
  outreach_sent: "bg-amber-50 text-amber-800 border-amber-200",
  replied: "bg-indigo-50 text-indigo-800 border-indigo-200",
  negotiating: "bg-fuchsia-50 text-fuchsia-800 border-fuchsia-200",
  converted: "bg-green-100 text-green-900 border-green-300",
  unsubscribed: "bg-gray-100 text-gray-500 border-gray-300",
  not_a_fit: "bg-red-50 text-red-700 border-red-200",
};

export function StatusPill({ status }) {
  const label = STATUS_LABELS[status] || status;
  const cls = STATUS_COLORS[status] || "bg-gray-100 text-gray-700 border-gray-300";
  return (
    <span
      className={`inline-flex items-center rounded-sm text-[11px] px-2 py-0.5 border ${cls} font-medium`}
      data-testid={`status-pill-${status}`}
    >
      {label}
    </span>
  );
}

export function ScoreBar({ score }) {
  if (score == null) return <span className="text-gray-400 text-xs">—</span>;
  const color =
    score >= 80 ? "#276749" : score >= 65 ? "#0369A1" : score >= 45 ? "#D97706" : "#9B2C2C";
  return (
    <div className="flex items-center gap-2 min-w-[80px]" data-testid="fit-score-bar">
      <div className="flex-1 h-1.5 bg-gray-200 rounded-sm overflow-hidden">
        <div className="h-full" style={{ width: `${score}%`, backgroundColor: color }} />
      </div>
      <span className="text-xs font-mono text-gray-700 w-6 text-right">{score}</span>
    </div>
  );
}
